import { ServiceBase } from '../../../core/services/ServiceBase'
import ChatBoxProxy from './proxy'

class ChatBoxService extends ServiceBase {
  getListTopic(params) {
    return this.getData(() => ChatBoxProxy.getListTopic(params))
  }

  getMessageInTopic(params) {
    return this.getData(() => ChatBoxProxy.getMessageInTopic(params))
  }

  updateTopic(params) {
    return this.getData(() => ChatBoxProxy.updateTopic(params))
  }

  getQuestion(params) {
    return this.getData(() => ChatBoxProxy.getQuestion(params))
  }

  getTopicMaxUpdatedDate(params) {
    return this.getData(() => ChatBoxProxy.getTopicMaxUpdatedDate(params))
  }
}

export default new ChatBoxService()
